import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AjaxError } from "../../_core/api/types";
import { getBillingAlertFailures, getMonitoringAccess } from "../api";
import { GetBillingAlertFailuresParams, GetBillingAlertFailuresResp, MonitoringAccess } from "../api/types";

export const useMonitoringAccess = (
  options?: Omit<UseQueryOptions<MonitoringAccess, AjaxError>, "queryKey" | "queryFn">
) => {
  return useQuery<MonitoringAccess, AjaxError>({
    queryKey: ["monitoringAccess"],
    queryFn: getMonitoringAccess,
    staleTime: 5 * 60 * 1000,
    ...options,
  });
};

export const useBillingAlertFailures = (
  parameters: GetBillingAlertFailuresParams,
  options?: Omit<UseQueryOptions<GetBillingAlertFailuresResp, AjaxError>, "queryKey" | "queryFn">
) => {
  return useQuery<GetBillingAlertFailuresResp, AjaxError>({
    queryKey: ["billingAlertFailures", parameters],
    queryFn: () => getBillingAlertFailures(parameters),
    ...options,
  });
};
